<div #truelearnToast [@srinkToast]="shrink ? 'shrink' : 'fullSize'">
    <div
        class="toast align-items-center fade show"
        [class]="cssClass"
        [ngClass]="{
            'bg-danger': type === ToastType.Error
        }"
        role="alert"
        aria-hidden="false"
        [attr.role]="type === ToastType.Error ? 'alert' : 'status'"
    >
        <div
            *ngIf="header"
            class="toast-header"
            [ngClass]="{
                'bg-danger': type === ToastType.Error
            }"
        >
            <span>{{ header }}</span>
            <button type="button" class="btn-close ms-2 mb-1" (click)="hide()" aria-label="Close"></button>
        </div>
        <div class="d-flex flex-row justify-content-between">
            <div class="toast-body">
                <ng-container *ngIf="!isMarkup(message)">
                    <span class="text-break">
                        {{ message }}
                    </span>
                </ng-container>
                <ng-container *ngIf="isMarkup(message)">
                    <ng-template [ngTemplateOutlet]="message"></ng-template>
                </ng-container>
            </div>
            <button
                *ngIf="!header"
                type="button"
                class="btn btn-sm btn-link text-white close-toast"
                [ngClass]="{
                    'bg-danger': type === ToastType.Error
                }"
                aria-label="Close"
                (click)="hide()"
            >
                Dismiss
            </button>
        </div>
    </div>
</div>
